import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components";

export const GoToSection = ({
  className = "",
  text = "",
  urlTitle = "",
  to = "",
}) => {
  return (
    <div
      className={`flex flex-row items-center my2 justify-center m-auto h2 block-font ${className}`}
    >
      <div className="mr2">{text}</div>
      <div>
        <Link to={to}>
          <Button>{urlTitle}</Button>
        </Link>
      </div>
    </div>
  );
};

export const GoToSections = ({
  className = "",
  next = { url: "", text: "" },
  previous = { url: "", text: "" },
}) => {
  return (
    <div
      className={`flex flex-row flex-wrap col-12 justify-between block-font items-center border-top h0 px3 my2`}
      style={!previous?.url ? { flexFlow: `row-reverse` } : {}}
    >
      {previous?.url && (
        <Link className="color-white my2" to={previous.url}>
          <span className="color-gray">Previous: </span> {previous?.text}
        </Link>
      )}
      {next?.url && (
        <Link className=" width-fit-content color-white my2" to={next.url}>
          <span className="color-gray">Next: </span> {next?.text}
        </Link>
      )}
      <div></div>
    </div>
  );
};
